import { apiUrl, performApiRequest } from '@/infrastructure/api-requests';
import { GetOrderByIdQuery, GetOrderIdentificationsByOrderNumberQuery, Order, OrderIdentification } from './types';

export function getOrderIdentificationsByOrderNumber(query: GetOrderIdentificationsByOrderNumberQuery): Promise<OrderIdentification[]> {
  const url = `${apiUrl}/api/order-search/get-order-identifications-by-order-number-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}

export function getOrderById(query: GetOrderByIdQuery): Promise<Order> {
  const url = `${apiUrl}/api/order-search/get-order-by-id-query`;
  return performApiRequest({ url, method: 'POST', data: query });
}
